/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Feat_4_TitleInputs */

const en_nfp_feat_4_title = /** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Trust`)
};

const es_nfp_feat_4_title = /** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confianza Verificada`)
};

const fr_nfp_feat_4_title = /** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confiance Vérifiée`)
};

const de_nfp_feat_4_title = /** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziertes Vertrauen`)
};

const id_nfp_feat_4_title = /** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kepercayaan Terverifikasi`)
};

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const ja_nfp_feat_4_title = en_nfp_feat_4_title;

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const zh_nfp_feat_4_title = en_nfp_feat_4_title;

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const ar_nfp_feat_4_title = en_nfp_feat_4_title;

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const it_nfp_feat_4_title = en_nfp_feat_4_title;

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const ru_nfp_feat_4_title = en_nfp_feat_4_title;

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const pt_nfp_feat_4_title = en_nfp_feat_4_title;

/** @type {(inputs: Nfp_Feat_4_TitleInputs) => LocalizedString} */
const ko_nfp_feat_4_title = en_nfp_feat_4_title;

/**
* | output |
* | --- |
* | "Verified Trust" |
*
* @param {Nfp_Feat_4_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_feat_4_title = /** @type {((inputs?: Nfp_Feat_4_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Feat_4_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_feat_4_title(inputs)
	if (locale === "es") return es_nfp_feat_4_title(inputs)
	if (locale === "fr") return fr_nfp_feat_4_title(inputs)
	if (locale === "de") return de_nfp_feat_4_title(inputs)
	if (locale === "ja") return ja_nfp_feat_4_title(inputs)
	if (locale === "zh") return zh_nfp_feat_4_title(inputs)
	if (locale === "ar") return ar_nfp_feat_4_title(inputs)
	if (locale === "id") return id_nfp_feat_4_title(inputs)
	if (locale === "it") return it_nfp_feat_4_title(inputs)
	if (locale === "ru") return ru_nfp_feat_4_title(inputs)
	if (locale === "pt") return pt_nfp_feat_4_title(inputs)
	return ko_nfp_feat_4_title(inputs)
});